/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { AndroidBuildVariantProto } from './android-build-variant-proto';
import { AndroidDisplayMetricsProto } from './android-display-metrics-proto';
import { AndroidMemoryProto } from './android-memory-proto';
import { AndroidOSBuildProto } from './android-osbuild-proto';
import { AndroidPackageInfoProto } from './android-package-info-proto';
import { FSFBDetectedFrameworks } from './fsfbdetected-frameworks';
import { FSFBStableSelectors } from './fsfbstable-selectors';

export class AndroidProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AndroidProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAndroidProto(bb: flatbuffers.ByteBuffer, obj?: AndroidProto): AndroidProto {
    return (obj || new AndroidProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsAndroidProto(
    bb: flatbuffers.ByteBuffer,
    obj?: AndroidProto,
  ): AndroidProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AndroidProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  appPackageName(): string | null;
  appPackageName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  appPackageName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  osBuild(obj?: AndroidOSBuildProto): AndroidOSBuildProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new AndroidOSBuildProto()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  memory(obj?: AndroidMemoryProto): AndroidMemoryProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new AndroidMemoryProto()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  packageInfo(obj?: AndroidPackageInfoProto): AndroidPackageInfoProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new AndroidPackageInfoProto()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  features(index: number): string;
  features(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  features(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  featuresLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  buildVariant(obj?: AndroidBuildVariantProto): AndroidBuildVariantProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new AndroidBuildVariantProto()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  display(obj?: AndroidDisplayMetricsProto): AndroidDisplayMetricsProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new AndroidDisplayMetricsProto()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  appName(): string | null;
  appName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  appName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  detectedFrameworks(index: number): FSFBDetectedFrameworks | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  detectedFrameworksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  detectedFrameworksArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  stableSelectorsCompose(): FSFBStableSelectors {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : FSFBStableSelectors.NOT_AVAILABLE;
  }

  static startAndroidProto(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addAppPackageName(builder: flatbuffers.Builder, appPackageNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, appPackageNameOffset, 0);
  }

  static addOsBuild(builder: flatbuffers.Builder, osBuildOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, osBuildOffset, 0);
  }

  static addMemory(builder: flatbuffers.Builder, memoryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, memoryOffset, 0);
  }

  static addPackageInfo(builder: flatbuffers.Builder, packageInfoOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, packageInfoOffset, 0);
  }

  static addFeatures(builder: flatbuffers.Builder, featuresOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, featuresOffset, 0);
  }

  static createFeaturesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startFeaturesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBuildVariant(builder: flatbuffers.Builder, buildVariantOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, buildVariantOffset, 0);
  }

  static addDisplay(builder: flatbuffers.Builder, displayOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, displayOffset, 0);
  }

  static addAppName(builder: flatbuffers.Builder, appNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, appNameOffset, 0);
  }

  static addDetectedFrameworks(
    builder: flatbuffers.Builder,
    detectedFrameworksOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(8, detectedFrameworksOffset, 0);
  }

  static createDetectedFrameworksVector(
    builder: flatbuffers.Builder,
    data: FSFBDetectedFrameworks[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startDetectedFrameworksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addStableSelectorsCompose(
    builder: flatbuffers.Builder,
    stableSelectorsCompose: FSFBStableSelectors,
  ) {
    builder.addFieldInt8(9, stableSelectorsCompose, FSFBStableSelectors.NOT_AVAILABLE);
  }

  static endAndroidProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
